// درج رمز یکبار مصرف
<template>
  <div
    class="
      container
      min-vh-100
      d-flex
      justify-content-center
      align-items-center
    "
  >
    <div class="row justify-content-center">
      <div
        class="
          col-sm-11 col-md-9 col-lg-8
          bg-white
          rounded
          shadow
          z-depth-1
          my-2
          wow
          fadeIn
          p-0
        "
      >
        <div class="row">
          <!-- کادر رنگی سمت راست -->
          <div
            class="
              col-3
              bg-dark
              d-flex
              flex-column
              justify-content-between
              align-items-center
              rounded-right
              shadow
              z-depth-1
              p-0
              py-3
            "
          >
            <!-- لوگو و نام نرم افزار -->
            <div class="row">
              <div class="col text-center p-0">
                <img
                  class="img-fluid px-4"
                  :src="ImageUrl + 'LogoSite.png'"
                  alt="LogoSite"
                />
                <span class="text-white" style="font-size: 12px"
                  >سامانه مالی پرش</span
                >
              </div>
            </div>

            <!-- نگارش و امضاء -->
            <div class="row">
              <div class="col text-center p-0">
                <span class="text-white d-block"
                  >نگارش : {{ getVersionApp }}</span
                >
                <span class="text-white d-block mt-2">پارس رایانه شاپرک</span>
              </div>
            </div>
          </div>

          <!-- مرکز فرم ورود -->
          <div class="col-9 p-5 p-md-5 d-flex flex-column text-right">
            <h4 class="mb-4 text-danger text-center">
              <strong>درج رمز یکبار مصرف</strong>
            </h4>
            <!-- مربوط به درج رمز یکبار مصرف -->
            <div>
              <h6 class="text-center" style="line-height: 32px">
                  پیامکی حاوی یک کد 5 رقمی ( رمز یکبار مصرف ) برای شما ارسال شد .
                  کد دریافتی را در کادر زیر درج نموده و سپس دکمه ورود به سامانه را کلیک نمایید .
              </h6>
              <!-- کادر رمز یکبار مصرف -->
              <div class="input-group my-4">
                  <input
                      type="text"
                      v-model="AcceptCode"
                      class="form-control text-center rounded-0"
                      placeholder="رمز یکبار مصرف پیامک شده را وارد نمایید"
                      autocomplete="off"
                      v-on:focus="$event.target.select()"
                      v-on:keypress="onlyNumberAccept"
                      v-on:keyup.enter="callCheckAcceptCode()"
                      style="direction: ltr"
                      maxlength="5"
                      id="inputAcceptCode"
                  />
              </div>
              <!-- کادر کپچا -->
              <div 
                v-if="showCaptcha"
                class="input-group my-4 justify-content-center"
              >
                <div class="text-center">
                  <img
                    class="rounded"
                    style="
                      border: 1px solid #ced4da;
                      border-radius: 5px !important;
                      width: 150px;
                      height: 50px;
                    "
                    :src="captchaImage"
                    alt="captcha"
                  />
                </div>
                <div class="my-3 w-100">
                  <div class="mb-2 text-dark">
                    <strong><i class="fa fa-lock ml-1"></i> کد امنیتی</strong>
                  </div>
                  <div class="input-group">
                    <input
                      id="captchatext"
                      v-model="captchatext"
                      type="text"
                      class="form-control text-center rounded-0"
                      placeholder="کد امنیتی موجود در تصویر بالا را وارد نمایید"
                      v-on:keyup.enter="LoginUser()"
                      style="direction: ltr"
                    />
                    <div class="input-group-prepend rounded-0">
                      <span class="input-group-text">
                        <a v-on:click="getCaptchaImage()">
                          <i class="fas fa-sync"></i>
                        </a>
                      </span>
                    </div>
                  </div>
                </div>
              </div>
              <div v-if="errorMessage != ''" class="row m-0 p-0 mb-3 justify-content-center">
                <span 
                  class="h6 text-danger text-center"
                  style="white-space: pre; line-height: 28px;"
                >{{errorMessage}}</span>
              </div>
              <!-- دکمه تایید و بازیابی رمز و بازگشت پایین فرم -->
              <div class="d-flex justify-content-between align-items-center">
                <div class="d-flex align-items-center">
                  <div
                    class="
                        d-inline-flex
                        justify-content-end
                        align-items-center
                        bg-secondary
                        rounded
                        hoverable
                        waves-effect
                    "
                  >
                    <a
                        v-on:click="callCheckAcceptCode()"
                        class="text-decoration-none px-4 py-2 text-white m-0 h6"
                    >
                        ورود به سامانه
                    </a>
                    <a
                        v-on:click="callCheckAcceptCode()"
                        style="background-color: #623879"
                        class="
                        text-decoration-none
                        p-2
                        py-3
                        text-white
                        m-0
                        rounded-left
                        "
                    >
                      <span class="p-0 m-0 h6 text-white">{{timeLeft}}</span>
                    </a>
                  </div>
                </div>
                <div
                  class="
                    d-inline-flex
                    justify-content-end
                  "
                >
                  <a
                    v-on:click="backToLogin()"
                    class="
                      m-0
                      h7
                      text-info
                      mt-2
                    "
                    title="بازگشت به فرم ورود"
                  >
                    بازگشت
                    <i class="fas fa-sign-out-alt fa-rotate-180 fa-lg mr-1"></i>
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { newRoutes } from "../../main";

export default {
  data() {
    return {
      intervalTimer: null,          // تایمر شمارنده زمان
      maxTimeForInserSMSCode: 300,  // مدت انتظار جهت درج رمز یکبار مصرف - 180 ثانیه معادل 3 دقیقه
      timeLeft: "00:00",            // مدت انتظار جهت نمایش به کاربر
      checkSendSMS: false,          // کنترل وضعیت ارسال پیامک رمز یکبار مصرف
      nationalID: '',               // کد ملی کاربر
      AcceptCode: '',               // رمز یکبار مصرف دریافتی از پیامک
      errorMessage: '',             // متن خطا
      captchatext: '',              // مقدار کپچا
      showCaptcha: false,           // وضعیت نمایش کپچا
      captchaImage: this.$store.getters.getImageUrl + "wait.gif",
    };
  },
  created() {
    this.checkLoginLevel();
    this.setTime(this.maxTimeForInserSMSCode);
  },
  computed: {
    ImageUrl() {
      // بازیابی آدرس تصاویر
      return this.$store.getters.getImageUrl;
    },
    getVersionApp() {
      // بازیابی شماره نگارش نرم افزار
      return this.$store.getters.getVersionApp;
    },
    checkErrorText() {
      // بازیابی خطای لاگین
      return this.$store.getters.getLoginError;
    },
  },
  methods: {
    // بررسی مرحله لاگین
    async checkLoginLevel(){
      // خالی کردن مقدار کپچای قبلی
      this.$store.commit('setCaptchaHash','');
      // درج کپچا در اولین ورود الزامی نیست
      this.$store.commit('setCaptchaIsRequired', false);
      // نمایش این فرم فقط در صورتی مجاز است که مرحله قبل کامل شده باشد
      let loginLevel = await this.$store.getters.getLoginLevel;
      if(loginLevel != 2){
        newRoutes.push("Login");
      } else {
        // انتقال فوکوس به کادر کد
        setTimeout(() => {
          $("#inputAcceptCode").focus();
          $("#inputAcceptCode").select();
        }, 500);
      }
    },
    // درج فقط عدد مجاز است
    onlyNumberAccept($event) {
      this.errorMessage = '';
      if (!/\d/.test($event.key)) {
        return $event.preventDefault();
      }
    },
    // مربوط به دکمه بازگشت
    backToLogin(){
      this.$store.commit('setLoginLevel', 1);
      newRoutes.push("Login");
    },
    // دریافت تصویر کپچا از سرور
    async getCaptchaImage() {
      var str = await this.$store.dispatch("GetCaptchaImage");
      if (str != null) this.captchaImage = str.toString();
      else {
        this.captchaImage = this.$store.getters.getImageUrl + "wait.gif";
        this.$store.dispatch("notify", {
          notText:
            "عدم دریافت تصویر امنیتی\nلطفا مجدد تلاش نمایید !",
          timeOut: 2500,
        });
      }
    },
    // مربوط به درج رمز یکبار مصرف
    async callCheckAcceptCode(){
      if(this.AcceptCode != ''){
        if(this.AcceptCode.length >= 5){
          // بررسی وضعیت درج کپچا الزامی است؟
          let checkCaptcha = await this.$store.getters.getCaptchaIsRequired;
          if(checkCaptcha == true){
            if(this.captchatext == ''){
              // درج کپچا الزامی است
              this.errorMessage = "ثبت کد امنیتی الزامی است !\nلطفا ابتدا کد امنیتی موجود در تصویر را وارد نمایید .";
              this.$store.dispatch("notify", {
                notText: "ثبت کد امنیتی الزامی است !\nلطفا ابتدا کد امنیتی موجود در تصویر را وارد نمایید .",
                timeOut: 2500,
              });
              return false;
            }
          }
          // نمایش لطفا صبر نمایید
          this.$store.dispatch("pleaseWait", {
            notText: "ورود به سامانه",
          });
          const checkAcceptCode = {
            nationalID: this.nationalID, 
            AcceptCode: this.AcceptCode,
            Captcha: this.captchatext,
            CaptchaHash: this.$store.getters.getCaptchaHash,
          }
          // ارسال پیامک بازیابی رمز
          let strCheckLogin = await this.$store.dispatch("LoginPart2_CheckAcceptCode", checkAcceptCode);
          if(strCheckLogin === "Captcha"){
              // نمایش کپچا و تلاش مجدد    
              this.getCaptchaImage();
              this.showCaptcha = true;          
          }
          // لغو نمایش لطفا صبر نمایید
          this.$store.dispatch("pleaseWait", {
            stop: true,
          });
        } else {
          // طول رمز یکبار مصرف معتبر نمی باشد
          this.errorMessage = "طول رمز یکبار مصرف معتبر نمی باشد !\nحداقل طول رمز یکبار مصرف ، 5 رقم است .";
          this.$store.dispatch("notify", {
            notText: "طول رمز یکبار مصرف معتبر نمی باشد !\nحداقل طول رمز یکبار مصرف ، 5 رقم است .",
            timeOut: 2500,
          });
        }
      } else {
        // رمز یکبار مصرف درج نشده است
        this.errorMessage = "رمز یکبار مصرف درج نشده است !\nدرج رمز یکبار مصرف الزامی است .";
        this.$store.dispatch("notify", {
          notText: "رمز یکبار مصرف درج نشده است !\nدرج رمز یکبار مصرف الزامی است .",
          timeOut: 3500,
        });
      }
    },
    // تابع شروع تایمر
    async setTime(seconds) {
      clearInterval(this.intervalTimer);
      this.timer(seconds);
    },
    timer(seconds) {
      const now = Date.now();
      const end = now + seconds * 1000;
      this.displayTimeLeft(seconds);

      this.selectedTime = seconds;
      this.countdown(end);
    },
    countdown(end) {
      // this.initialTime = this.selectedTime;
      this.intervalTimer = setInterval(() => {
        const secondsLeft = Math.round((end - Date.now()) / 1000);

        if (secondsLeft <= 0) {
          clearInterval(this.intervalTimer);
          // پایان زمان درج رمز یکبار مصرف
          this.checkSendSMS = false;
          return;
        }
        this.displayTimeLeft(secondsLeft);
      }, 1000);
    },
    displayTimeLeft(secondsLeft) {
      const minutes = Math.floor((secondsLeft % 3600) / 60);
      const seconds = secondsLeft % 60;

      this.timeLeft =
        minutes.toLocaleString("en-US", {
          minimumIntegerDigits: 2,
          useGrouping: false,
        }) +
        ":" +
        seconds.toLocaleString("en-US", {
          minimumIntegerDigits: 2,
          useGrouping: false,
        });
    },
  },
  watch: {
    AcceptCode: function () {
      this.errorMessage = "";
    },
    captchatext: function () {
      this.errorMessage = "";
    },
    checkErrorText() {
      // تحت نظر گرفتن متغییر مربوط به خطای لاگین
      this.errorMessage = this.$store.getters.getLoginError;
      if (this.errorMessage != "") {
        // this.captchatext = "";
        this.getCaptchaImage();
      }
    },
  },
};
</script>


// WEBPACK FOOTER //
// src/pages/Login/CheckAcceptCode.vue